"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar as ChakraAvatar, forwardRef, useMultiStyleConfig, } from "@chakra-ui/react";
import { SvgSpriteConsumer } from "../SvgSprite";
const WHITESPACE_REGEX = /\s+/;
const Avatar = forwardRef((_a, ref) => {
    var { icon = _jsx(SvgSpriteConsumer, { svgId: "person24", size: 24 }), name = "", variant } = _a, rest = __rest(_a, ["icon", "name", "variant"]);
    const styles = useMultiStyleConfig("Avatar", { variant });
    return (_jsx(ChakraAvatar, Object.assign({ sx: styles.container, ref: ref, icon: icon, name: WHITESPACE_REGEX.test(name) ? name : "" }, rest)));
});
Avatar.displayName = "Avatar";
export default Avatar;
//# sourceMappingURL=Avatar.js.map